// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HasGroupTagQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HasGroupTagQuery = { __typename?: 'Query', features?: { __typename: 'Features', id: string, isVip?: boolean } };

export type HasGroupTagFragment = { __typename: 'Features', id: string, isVip?: boolean };

export const HasGroupTagFragmentDoc = /*#__PURE__*/ gql`
    fragment HasGroupTagFragment on Features {
  __typename
  id
  isVip: hasGroupTag(name: "VIP Manager")
}
    `;
export const HasGroupTagQueryDocument = /*#__PURE__*/ gql`
    query HasGroupTagQuery {
  features {
    ...HasGroupTagFragment
  }
}
    ${HasGroupTagFragmentDoc}`;
export function useHasGroupTagQuery(baseOptions?: Apollo.QueryHookOptions<HasGroupTagQuery, HasGroupTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasGroupTagQuery, HasGroupTagQueryVariables>(HasGroupTagQueryDocument, options);
      }
export function useHasGroupTagQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasGroupTagQuery, HasGroupTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasGroupTagQuery, HasGroupTagQueryVariables>(HasGroupTagQueryDocument, options);
        }
export function useHasGroupTagQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasGroupTagQuery, HasGroupTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasGroupTagQuery, HasGroupTagQueryVariables>(HasGroupTagQueryDocument, options);
        }
export type HasGroupTagQueryHookResult = ReturnType<typeof useHasGroupTagQuery>;
export type HasGroupTagQueryLazyQueryHookResult = ReturnType<typeof useHasGroupTagQueryLazyQuery>;
export type HasGroupTagQuerySuspenseQueryHookResult = ReturnType<typeof useHasGroupTagQuerySuspenseQuery>;
export type HasGroupTagQueryQueryResult = Apollo.QueryResult<HasGroupTagQuery, HasGroupTagQueryVariables>;